import React, { FC, Fragment } from 'react';
import { Button, Card, CardBody, CardText, Col, FormText, Row } from 'reactstrap';
import { useTranslation } from '../translations';
import { MaterialIcon } from '.';

export interface ElementListItem {
  id: number;
  name: string;
}

interface ElementListProps {
  readonly elements: ElementListItem[];
  readonly onDelete?: (id: number) => void;
}

export const ElementList: FC<ElementListProps> = ({ elements, onDelete }) => {
  const { ts } = useTranslation();
  if (elements.length === 0) {
    return (
      <Card>
        <CardBody>
          <FormText color="muted">{ts('attendee_search.no_results_found')}</FormText>
        </CardBody>
      </Card>
    );
  }

  return (
    <Card>
      <CardBody>
        <CardText>
          <Row>
            {elements.map((element) => (
              <Fragment key={element.id}>
                {onDelete && (
                  <Col lg={2} xs={12}>
                    <Button
                      block
                      color="danger"
                      id={`deleteElement${element.id}`}
                      onClick={() => {
                        onDelete(element.id);
                      }}
                      outline
                      type="submit"
                    >
                      <MaterialIcon name="delete" />
                    </Button>
                  </Col>
                )}
                <Col lg={onDelete ? 10 : 12} style={{ marginTop: '6px' }} xs={12}>
                  {element.name}
                </Col>
                <Col xs={12}>
                  <hr />
                </Col>
              </Fragment>
            ))}
          </Row>
        </CardText>
      </CardBody>
    </Card>
  );
};
